import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../Admin/Admin.css';
import CollapseCard from '../CollapseCard/CollapseCard';
import Forms from './Forms';
import FormFields from './FormFields';
import FormSelects from './FormSelects';

class FormsContainer extends Component {
    constructor(props) {
        super(props);
        this.blankForm = {
            formId: 0,
            name: '',
            order: 0,
            active: true,
            config: '',
            formFields: []
        }
        this.blankFormField = {
            formFieldId: 0,
            field: '',
            uniqueId: '',
            type: '',
            required: false,
            default: '',
            limit: '',
            order: 0,
            active: true,
            rules: '',
            forms: [],
            uniqueIdEdited: false
        }
        this.blankFormSelect = {
            formSelectId: 0,
            name: '',
            options: '',
            default: '',
            order: 0,
            active: true,
            selectOptions: [],
        }
        this.state = {
            forms: [],
            formId: 0,
            formFields: [],
            formFieldId: 0,
            formSelects: [],
            formSelectId: 0,
            editForm: { ...this.blankForm },
            editFormField: { ...this.blankFormField },
            editFormSelect: { ...this.blankFormSelect },
            newForm: { ...this.blankForm },
            newFormField: { ...this.blankFormField },
            newFormSelect: { ...this.blankFormSelect },
            isFormsLoaded: false,
            isFormFieldsLoaded: false,
            isFormSelectsLoaded: false,
        };
    }

    componentDidMount() {
        this.props.log('FormsContainer.js/componentDidMount');
        this.getForms();
    }

    getForms = () => {
        this.props.log('FormsContainer.js/getForms');
        fetch('/api/forms/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        forms: results.data,
                        isFormsLoaded: true
                    }, () => { this.getFormFields(); this.getFormSelects(); });
                } else {
                    this.props.addToast('Unable to load forms.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getFormFields = () => {
        this.props.log('FormsContainer.js/getFormFields');
        fetch('/api/form-fields/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        formFields: results.data,
                        isFormFieldsLoaded: true
                    });
                } else {
                    this.props.addToast('Unable to load form fields.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getFormSelects = () => {
        this.props.log('FormsContainer.js/getFormSelects');
        fetch('/api/form-selects/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        formSelects: results.data,
                        isFormSelectsLoaded: true
                    });
                } else {
                    this.props.addToast('Unable to load form selects.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditForm = (formId) => {
        this.props.log('FormsContainer.js/onEditForm (formId)', formId);
        let form = [...this.state.forms].filter(item => item.formId === formId)[0];
        const obj = {
            formId: form.formId,
            name: form.name,
            order: form.order,
            active: form.active,
            config: form.config,
            formFields: form.formFields != null ? form.formFields : [],
        }
        this.setState({
            formId: form.formId,
            editForm: obj
        });
    }

    onDeleteForm = (formId) => {
        this.props.log('FormsContainer.js/onDeleteForm (formId)', formId);
        fetch('/api/forms/' + formId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Form deleted successfully.', 5, 'success')
                    this.getForms();
                } else {
                    this.props.addToast('Unable to delete form.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeForm = (e, type) => {
        this.props.log('FormsContainer.js/onChangeForm (e, type)', e, type);
        e.persist();
        let thisForm = (type === 'edit') ?
            this.state.editForm : this.state.newForm
        switch (e.target.name) {
            case "active":
                thisForm[e.target.name] = !thisForm[e.target.name];
                break;
            case "formFields":
                const formFieldId = parseInt(String(e.target.id).split('_')[1]);
                const index = thisForm.formFields.findIndex(item => item.formFieldId === formFieldId);
                if (index > -1) thisForm.formFields.splice(index, 1);
                if (e.target.checked) thisForm.formFields.push({ formFieldId: formFieldId, order: 10000 });
                break;
            default:
                thisForm[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editForm: thisForm } : { newForm: thisForm };
        });
    }

    handleCancelForm = () => {
        this.props.log('FormsContainer.js/handleCancelForm');
        this.setState({
            editForm: { ...this.blankForm }
        });
    }

    handleAddForm = () => {
        this.props.log('FormsContainer.js/handleAddForm');
        let newOrder = Math.max(...this.state.forms.map(i => i['order']), 0) + 10;
        fetch('/api/forms/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newForm.name,
                order: newOrder,
                active: this.state.newForm.active,
                config: this.state.newForm.config
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newForm: { ...this.blankForm }
                    }, () => this.getForms());
                    this.props.addToast('Form added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add form.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEditForm = () => {
        this.props.log('FormsContainer.js/handleEditForm');
        fetch('/api/forms/' + this.state.editForm.formId, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editForm.name,
                active: this.state.editForm.active,
                formFields: this.state.editForm.formFields,
                config: this.state.editForm.config
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editForm: { ...this.blankForm },
                        editFormField: { ...this.blankFormField }
                    }, () => this.getForms());
                    this.props.addToast('Form updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update form.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeFormField = (e, type) => {
        this.props.log('FormsContainer.js/onChangeFormField (e,type)', e, type);
        e.persist();
        let thisFormField = (type === 'edit') ? this.state.editFormField : this.state.newFormField;
        switch (e.target.name) {
            case "active":
            case "required":
                thisFormField[e.target.name] = !thisFormField[e.target.name];
                break;
            case "field":
                thisFormField[e.target.name] = e.target.value;
                if (!thisFormField.uniqueIdEdited) thisFormField.uniqueId = this.camelize(e.target.value);
                break;
            case "uniqueId":
                thisFormField.uniqueIdEdited = true;
                thisFormField[e.target.name] = e.target.value;
                break;
            case "forms":
                const formId = parseInt(String(e.target.id).split('_')[1]);
                const index = thisFormField.forms.findIndex(item => item.formId === formId);
                if (index > -1) thisFormField.forms.splice(index, 1);
                if (e.target.checked) thisFormField.forms.push({ formId: formId, order: 10000 });
                break;
            default:
                thisFormField[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editFormField: thisFormField } : { newFormField: thisFormField };
        });
    }

    onEditFormField = (formFieldId) => {
        this.props.log('FormsContainer.js/onEditFormField (formFieldId)', formFieldId);
        const thisFormField = [...this.state.formFields].filter(item => item.formFieldId === formFieldId)[0];
        this.setState({
            formFieldId: formFieldId,
            editFormField: {
                formFieldId: formFieldId,
                field: thisFormField.field,
                uniqueId: thisFormField.uniqueId,
                type: thisFormField.type != null ? thisFormField.type : '',
                required: thisFormField.required,
                default: thisFormField.default,
                limit: thisFormField.limit,
                order: thisFormField.order,
                active: thisFormField.active,
                rules: thisFormField.rules,
                forms: thisFormField.forms != null ? thisFormField.forms : []
            }
        })
    }

    onDeleteFormField = (formFieldId) => {
        this.props.log('FormsContainer.js/onDeleteFormField (formFieldId)', formFieldId);
        fetch('/api/form-fields/' + formFieldId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Form field deleted successfully.', 5, 'success')
                    this.getForms();
                } else {
                    this.props.addToast('Unable to delete form field.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancelFormField = () => {
        this.props.log('FormsContainer.js/handleCancelFormField');
        this.setState({
            editFormField: { ...this.blankFormField },
        })
    }

    handleEditFormField = () => {
        this.props.log('FormsContainer.js/handleEditFormField');
        fetch('/api/form-fields/' + this.state.editFormField.formFieldId, {
            method: 'PUT',
            body: JSON.stringify({
                field: this.state.editFormField.field,
                uniqueId: this.state.editFormField.uniqueId,
                type: this.state.editFormField.type,
                required: this.state.editFormField.required,
                default: this.state.editFormField.default,
                limit: this.state.editFormField.limit,
                order: this.state.editFormField.order,
                active: this.state.editFormField.active,
                rules: this.state.editFormField.rules,
                forms: this.state.editFormField.forms
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editForm: { ...this.blankForm },
                        editFormField: { ...this.blankFormField }
                    }, () => this.getForms());
                    this.props.addToast('Form field updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update form field.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAddFormField = (e) => {
        this.props.log('FormsContainer.js/handleAddFormField');
        let newOrder = Math.max(...this.state.formFields.map(i => i['order']), 0) + 10;
        fetch('/api/form-fields/', {
            method: 'POST',
            body: JSON.stringify({
                field: this.state.newFormField.field,
                uniqueId: this.state.newFormField.uniqueId,
                type: this.state.newFormField.type,
                required: this.state.newFormField.required,
                default: this.state.newFormField.default,
                limit: this.state.newFormField.limit,
                order: newOrder,
                active: this.state.newFormField.active,
                rules: this.state.newFormField.rules
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-DB': this.props.clientId
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newFormField: { ...this.blankFormField }
                    }, () => this.getForms());
                    this.props.addToast('Form field added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add form field.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditFormSelect = (formSelectId) => {
        this.props.log('FormsContainer.js/onEditFormSelect (formSelectId)', formSelectId);
        let formSelect = [...this.state.formSelects].filter(item => item.formSelectId === formSelectId)[0];
        const obj = {
            formSelectId: formSelect.formSelectId,
            name: formSelect.name,
            options: formSelect.options,
            default: formSelect.default,
            order: formSelect.order,
            active: formSelect.active,
            formFields: formSelect.formFields != null ? formSelect.formFields : [],
        }
        this.setState({
            formSelectId: formSelect.formSelectId,
            editFormSelect: obj
        });
    }

    onDeleteFormSelect = (formSelectId) => {
        this.props.log('FormsContainer.js/onDeleteFormSelect (formSelectId)', formSelectId);
        fetch('/api/form-selects/' + formSelectId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Form select deleted successfully.', 5, 'success')
                    this.getForms();
                } else {
                    this.props.addToast('Unable to delete form select.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeFormSelect = (e, type) => {
        this.props.log('FormsContainer.js/onChangeFormSelect (e, type)', e, type);
        e.persist();
        let thisFormSelect = (type === 'edit') ?
            this.state.editFormSelect : this.state.newFormSelect
        switch (e.target.name) {
            case "active":
                thisFormSelect[e.target.name] = !thisFormSelect[e.target.name];
                break;
            case "formFields":
                const formFieldId = parseInt(String(e.target.id).split('_')[1]);
                const index = thisFormSelect.formFields.findIndex(item => item.formFieldId === formFieldId);
                if (index > -1) thisFormSelect.formFields.splice(index, 1);
                if (e.target.checked) thisFormSelect.formFields.push({ formFieldId: formFieldId });
                break;
            default:
                thisFormSelect[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editFormSelect: thisFormSelect } : { newFormSelect: thisFormSelect };
        });
    }

    handleCancelFormSelect = () => {
        this.props.log('FormsContainer.js/handleCancelFormSelect');
        this.setState({
            editFormSelect: { ...this.blankFormSelect }
        });
    }

    handleAddFormSelect = () => {
        this.props.log('FormsContainer.js/handleAddFormSelect');
        let newOrder = Math.max(...this.state.formSelects.map(i => i['order']), 0) + 10;
        fetch('/api/form-selects/', {
            method: 'POST',
            body: JSON.stringify({
                name: this.state.newFormSelect.name,
                options: this.state.newFormSelect.options,
                default: this.state.newFormSelect.default,
                order: newOrder,
                active: this.state.newFormSelect.active,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newFormSelect: { ...this.blankFormSelect }
                    }, () => this.getForms());
                    this.props.addToast('Form select added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add form select.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEditFormSelect = () => {
        this.props.log('FormsContainer.js/handleEditFormSelect');
        fetch('/api/form-selects/' + this.state.editFormSelect.formSelectId, {
            method: 'PUT',
            body: JSON.stringify({
                name: this.state.editFormSelect.name,
                options: this.state.editFormSelect.options,
                default: this.state.editFormSelect.default,
                active: this.state.editFormSelect.active,
                formFields: this.state.editFormSelect.formFields,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editFormSelect: { ...this.blankFormSelect },
                    }, () => this.getForms());
                    this.props.addToast('Form select updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update form select.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    setDragTarget = (formId) => {
        this.props.log('FormsContainer.js/setDragTarget (formId)', formId);
        this.setState({
            formId: formId
        })
    }

    camelize = (str) => {
        this.props.info('FormsContainer.js/camelize (str)', str);
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
            if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    }

    reorder = () => {
        this.props.log('FormsContainer.js/reorder');
        let dbForms = [];
        let data = [...this.state.forms];
        data = data.map((form, formIndex) => {
            if (dbForms.findIndex(item => item.formId === form.formId) === -1) dbForms.push({ formId: form.formId, order: (formIndex + 1) * 10 })
            return { ...form, order: (formIndex + 1) * 10 }
        })
        this.setState({ forms: data }, () => {
            fetch('/api/forms-order/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                },
                body: JSON.stringify(
                    { forms: dbForms, formFields: [] }
                )
            }, () => this.getForms())
        });
    }

    reorderFormFields = () => {
        this.props.log('FormsContainer.js/reorderFormFields');
        let dbFormFields = [];
        let data = [...this.state.formFields];
        data = data.map((formField, formFieldIndex) => {
            if (dbFormFields.findIndex(item => item.formFieldId === formField.formFieldId) === -1) dbFormFields.push({ formFieldId: formField.formFieldId, order: (formFieldIndex + 1) * 10 })
            return { ...formField, order: (formFieldIndex + 1) * 10 }
        })
        this.setState({ formFields: data }, () => {
            fetch('/api/forms-order/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                },
                body: JSON.stringify(
                    { forms: [], formFields: dbFormFields }
                )
            }, () => this.getForms())
        });
    }

    render() {
        this.props.info('FormsContainer.js/render');
        const dragProps = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = [...this.state.forms]
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.setState({ forms: data }, () => this.reorder());
            },
            nodeSelector: 'div.formRow',
            handleSelector: 'span.dragIcon'
        };
        const dragPropsFields = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = { ...this.state.editForm };
                let dataFormFields = data.formFields;
                const item = dataFormFields.splice(fromIndex, 1)[0];
                dataFormFields.splice(toIndex, 0, item);
                dataFormFields = dataFormFields.map((formField, formFieldIndex) => {
                    return { ...formField, order: (formFieldIndex + 1) * 10 }
                })
                data.formFields = dataFormFields;
                this.setState({ editForm: data });
            },
            nodeSelector: 'div.fieldRow',
            handleSelector: 'span.dragIcon'
        };
        const dragPropsFormField = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = [...this.state.formFields];
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.setState({ formFields: data },
                    () => this.reorderFormFields()
                );
            },
            nodeSelector: 'div.formFieldRow',
            handleSelector: 'span.dragIconFormField'
        };

        return (
            (this.state.isFormsLoaded && this.state.isFormFieldsLoaded && this.state.isFormSelectsLoaded) ?
                <>
                    <CollapseCard title="Form Management" open={true}>
                        <Forms
                            {...this.props}
                            forms={this.state.forms}
                            formFields={this.state.formFields}
                            newForm={this.state.newForm}
                            editForm={this.state.editForm}
                            dragProps={dragProps}
                            dragPropsFields={dragPropsFields}
                            onChange={this.onChangeForm}
                            onEdit={this.onEditForm}
                            onDelete={this.onDeleteForm}
                            handleAdd={this.handleAddForm}
                            handleEdit={this.handleEditForm}
                            handleCancel={this.handleCancelForm}
                            setDragTarget={this.setDragTarget}
                            log={this.props.log}
                            info={this.props.info}
                        />
                    </CollapseCard>
                    <CollapseCard title="Form Fields" open={false}>
                        <FormFields
                            {...this.props}
                            forms={this.state.forms}
                            formFields={this.state.formFields}
                            newFormField={this.state.newFormField}
                            editFormField={this.state.editFormField}
                            dragPropsFormField={dragPropsFormField}
                            onChange={this.onChangeFormField}
                            onEdit={this.onEditFormField}
                            onDelete={this.onDeleteFormField}
                            handleAdd={this.handleAddFormField}
                            handleEdit={this.handleEditFormField}
                            handleCancel={this.handleCancelFormField}
                            log={this.props.log}
                            info={this.props.info}
                        />
                    </CollapseCard>
                    <CollapseCard title="Form Dropdowns" open={true}>
                        <FormSelects
                            {...this.props}
                            formSelects={this.state.formSelects}
                            formFields={this.state.formFields}
                            newFormSelect={this.state.newFormSelect}
                            editFormSelect={this.state.editFormSelect}
                            onChange={this.onChangeFormSelect}
                            onEdit={this.onEditFormSelect}
                            onDelete={this.onDeleteFormSelect}
                            handleAdd={this.handleAddFormSelect}
                            handleEdit={this.handleEditFormSelect}
                            handleCancel={this.handleCancelFormSelect}
                            log={this.props.log}
                            info={this.props.info}
                        />
                    </CollapseCard>
                </>
                :
                <h3>Loading...</h3>
        );

    }
}

export default FormsContainer;
